module.exports = __webpack_public_path__ + "static/media/logo-horizontal-blanco.0fe73af0.svg";